// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTextOutlinedSvg from "@fishx/icons-svg/es/asn/FileTextOutlined";
import FishxIcon from '../components/FishxIcon';

var FileTextOutlined = function FileTextOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTextOutlinedSvg
  }));
};

FileTextOutlined.displayName = 'FileTextOutlined';
export default React.forwardRef(FileTextOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileTextOutlined.js
// module id = 2750
// module chunks = 0